import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type TLandingMessageProps = {
	align?: "start" | "end";
	className?: string;
	children: ReactNode;
};

/**
 * Landing-owned message row. Do not use the rebrand `Message` primitive here —
 * it ships `text-sm`, `rounded-full`, and `bg-muted` that Next's CSS order can
 * apply over the landing type scale and square avatars.
 */
export function LandingMessage({ align = "start", className, children }: TLandingMessageProps) {
	return (
		<div
			className={cn(
				"relative flex w-full min-w-0 gap-2",
				{
					"flex-row-reverse": align === "end",
				},
				className,
			)}
		>
			{children}
		</div>
	);
}

export function LandingMessageAvatar({ className, children }: { className?: string; children: ReactNode }) {
	return (
		<div className={cn("flex w-fit shrink-0 items-start justify-center self-start overflow-hidden", className)}>
			{children}
		</div>
	);
}

export function LandingMessageContent({ className, children }: { className?: string; children: ReactNode }) {
	return <div className={cn("flex min-w-0 flex-col gap-2.5", className)}>{children}</div>;
}
